module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component component-backoffice-note"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('ActionButton', {
    attrs: {
      "confirm": "confirm",
      "action": _vm.remove
    }
  }, [_vm._v("Delete")])], 1)])], 1), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("PD" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Start")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.start))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("End")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.end))])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Capabilities")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.capabilities.routes.join(", ")))])]), _c('div', {
    staticClass: "column shrink"
  }, [_c('span', {
    staticClass: "fa",
    class: _vm.what,
    style: (_vm.hasReservations),
    on: {
      "click": function($event) {
        _vm.expanded = !_vm.expanded
      }
    }
  })])]), (_vm.expanded && _vm.item.pass_reservations.length) ? [_c('h2', [_vm._v("Pass reservations")]), _vm._l((_vm.item.pass_reservations), function(reservation, i) {
    return [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('label', [_vm._v("Status")]), _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(reservation.status))])]), _c('div', {
      staticClass: "column"
    }, [_c('label', [_vm._v("Service date")]), _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(reservation.service_date))])]), _c('div', {
      staticClass: "column"
    }, [_c('label', [_vm._v("Booked at")]), _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(reservation.created_at))])])]), _c('hr')]
  })] : _vm._e()], 2)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41e66d50!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/PassDriver.vue
// module id = 2445
// module chunks = 1